// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteV1NotificationsByIdData, DeleteV1NotificationsByIdResponses, GetV1NotificationsData, GetV1NotificationsResponses, PutV1NotificationsByIdStatusData, PutV1NotificationsByIdStatusResponses, PutV1NotificationsStatusReadData, PutV1NotificationsStatusReadResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get notifications using the given filters
 */
export const getV1Notifications = <ThrowOnError extends boolean = false>(options?: Options<GetV1NotificationsData, ThrowOnError>): RequestResult<GetV1NotificationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetV1NotificationsResponses, unknown, ThrowOnError>({ url: '/v1/notifications', ...options });

/**
 * Mark 1000 notifications as read
 *
 * Marks 1000 of the user's notifications as read. The frontend is expected to call this
 * endpoint in a loop until the returned `updated` count is less than 1000.
 *
 */
export const putV1NotificationsStatusRead = <ThrowOnError extends boolean = false>(options?: Options<PutV1NotificationsStatusReadData, ThrowOnError>): RequestResult<PutV1NotificationsStatusReadResponses, unknown, ThrowOnError> => (options?.client ?? client).put<PutV1NotificationsStatusReadResponses, unknown, ThrowOnError>({ url: '/v1/notifications/status-read', ...options });

/**
 * Update notification status
 */
export const putV1NotificationsByIdStatus = <ThrowOnError extends boolean = false>(options: Options<PutV1NotificationsByIdStatusData, ThrowOnError>): RequestResult<PutV1NotificationsByIdStatusResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutV1NotificationsByIdStatusResponses, unknown, ThrowOnError>({
    url: '/v1/notifications/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a notification
 */
export const deleteV1NotificationsById = <ThrowOnError extends boolean = false>(options: Options<DeleteV1NotificationsByIdData, ThrowOnError>): RequestResult<DeleteV1NotificationsByIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteV1NotificationsByIdResponses, unknown, ThrowOnError>({ url: '/v1/notifications/{id}', ...options });
